import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, textSize } from '@styles';

export const Container = ({ children, isSidesPadding = false }) => {
  return <ContentContainer isSidesPadding={isSidesPadding}>{children}</ContentContainer>;
};

const ContentContainer = styled.div`
  padding: ${(p) => (p.isSidesPadding ? '40px 16px 80px' : '22px 0 80px')};
  ${textSize('body')};
  color: ${Colors.graphite};
  font-weight: 400;

  @media ${Points.tablet_landscape} {
    padding: ${(p) => (p.isSidesPadding ? '40px 28px 100px' : '20px 0 100px')};
  }

  @media ${Points.laptop_wide} {
    padding: ${(p) => (p.isSidesPadding ? '50px 80px 120px' : '20px 0 120px')};
  }

  @media ${Points.fullhd} {
    padding: ${(p) => (p.isSidesPadding ? '60px 80px 160px' : '30px 0 160px')};
  }
`;
